import React, { useState, useEffect, useRef } from "react";
// import { useParams } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { Oval } from "react-loader-spinner";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import HttpService from "../../services/httpService";
import CryptoJs from "crypto-js";
import moment from 'moment';
import {
    Button, Paper, Box, Typography, Table, TableBody, TableCell,TableContainer, TableHead, TableRow, TextField, IconButton, Chip,Card, CardContent,Grid, Divider,Container,TablePagination,Tooltip, Avatar,LinearProgress,Dialog,DialogTitle, DialogContent, DialogActions,Checkbox
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import DownloadIcon from "@material-ui/icons/GetApp";
import HistoryIcon from "@material-ui/icons/History";
import PaymentIcon from "@material-ui/icons/Payment";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import PendingIcon from "@material-ui/icons/Schedule";
import BusinessIcon from "@material-ui/icons/Business";
import SendIcon from "@material-ui/icons/Send";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import SyncIcon from "@material-ui/icons/Sync";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import {
    Close as CloseIcon,
    Email as EmailIcon,
} from "@material-ui/icons";
import { isDK } from "../../utils/index";

import * as XLSX from "xlsx";
import { CSVLink } from "react-csv";
import EditIcon from "@material-ui/icons/Edit";
import {
    Edit3, FileText, Download, Calendar, User, CheckCircle, X, Send,
} from "lucide-react";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: "#f8fafc",
        minHeight: "100vh",
        padding: theme.spacing(3),
    },
    tableContainer: {
        borderRadius: 12,
        overflow: "hidden",
        marginTop: theme.spacing(3),
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    },
    tableRow: {
        transition: "all 0.2s ease",
        "&:hover": {
            backgroundColor: "#f9fafb",
            transform: "scale(1.005)",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        },
        "&:nth-of-type(even)": {
            backgroundColor: "#fafbfc",
        },
    },
}));

const VendorPOPayment = (props) => {
    const { userDetails } = useSelector((state) => state.user);
    const classes = useStyles();
    const ref = useRef(null);
    //  state initilizing from here....
    const [otpSend, setOtpSend] = useState(false);
    const [otpResponse, setOtpResponse] = useState([]);
    const [otpVerified, setOtpVerified] = useState(false);
    const [paymentData, setPaymentData] = useState([]);
    const [selectedPaymentData, setSelectedPaymentData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [approvalLoading, setApprovalLoading] = useState(false);
    const [dkModalOpen, setDkModalOpen] = useState(false);
    const [paymentmodalOpen, setPaymentmodalOpen] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [processingProgress, setProcessingProgress] = useState(0);
    const [processingMessage, setProcessingMessage] = useState('');
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [canCloseModal, setCanCloseModal] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [loadingg, setLoadingState] = useState(true);
    const [uploadCooldown, setUploadCooldown] = useState(false);
   const [cooldownTimeLeft, setCooldownTimeLeft] = useState(0);
   const [cooldownInterval, setCooldownInterval] = useState(null);
   const [excelLink, setExcelLink] = useState("");
   const [page, setPage] = useState(0); 
   const [rowsPerPage, setRowsPerPage] = useState(100);
   const [totalDocs, setTotalDocs] = useState(0);
   const [dateFilter, setDateFilter] = useState({
    startDate: "",
    endDate: ""
});
  //  edit option 
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [editLoading, setEditLoading] = useState(false);
  const [editSaving, setEditSaving] = useState(false);
  const [editRemark, setEditRemark] = useState("");
  const [editPayments, setEditPayments] = useState([]);   
  const [editTotals, setEditTotals] = useState({ payableAmount: 0, paidAmount: 0, remainingAmount: 0, payNowAmount: 0 });
  const [editAmount, setEditAmount] = useState("");
 // ── Sync state ───
    const [syncModalOpen, setSyncModalOpen] = useState(false);
    const [snorkelLogs, setSnorkelLogs] = useState([]);
    const [syncLogsLoading, setSyncLogsLoading] = useState(false);
    const [selectedSyncLog, setSelectedSyncLog] = useState(null);
    const [syncRunning, setSyncRunning] = useState(false);
    const [syncResultModal, setSyncResultModal] = useState(false);
    const [syncResult, setSyncResult] = useState(null);
 
    const pendingS3LinkRef = useRef(null);

const handleDateChange = (e) => {
    setDateFilter({
        ...dateFilter,
        [e.target.name]: e.target.value
    });
};
   const excelHeaders = [
    "SL No",
    "Type", 
    "Vendor Name",
    "Order ID",
    "Account No",
    "Date",
    "Amount",
    "IFSC",
    "Bank",
    "Email"
];
    // Function to generate Excel and upload to S3 
 const generateAndUploadExcel = async (selectedData) => {
    try {
        // Finding max number of IDs
        const maxIdsLength = Math.max(
            ...selectedData.map(item =>
                (item.approvedPaymentIds || "").split("/").filter(Boolean).length
            )
        );
        // Maping the data to match the header structure
        const formattedData = selectedData.map((item, index) => {
            const ids = (item.approvedPaymentIds || "").split("/");
            let dynamicCols = {};
            for (let i = 0; i < maxIdsLength; i++) {
                dynamicCols[`Col${i + 1}`] = ids[i] || "";
            }
            
            return {
                "SL No": index + 1,
                "Type": item.paymentType,
                "Vendor Name": item.vendorName,
                "Order ID": item.orderId,
                "Account No": item.accountNumber,
                "Date": item.date,
                "Amount": item.amount,
                "IFSC": item.ifsc,
                "Bank": item.bankName,
                "Email": item.email,
                ...dynamicCols
            }
        });
        const totalAmount = selectedData.reduce((sum, item) => sum + (Number(item.amount) || 0), 0);


        // Create workbook and worksheet
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(formattedData, { 
            header: excelHeaders 
        });

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Vendor Payments');

        // Generate Excel file as array buffer
        const excelBuffer = XLSX.write(workbook, { 
            type: 'array', 
            bookType: 'xlsx' 
        });

        // Create blob from buffer
        const blob = new Blob([excelBuffer], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });

        // Create FormData for upload
        const formData = new FormData();
        const filename = `VendorPayments_${Date.now()}.xlsx`;
        formData.append('file', blob, filename);

        // Upload to S3 using your existing API
        const response = await HttpService.uploadFile(formData);
        const s3Link = response.data.s3Link || response.data;
        // Return both link and total
       return { s3Link, totalAmount };

    } catch (error) {
        console.error('Error generating/uploading Excel:', error);
        throw error;
    }
  };
  // Function to set OTP message  and send whats app message after generating excel and uploading to s3
    const setOTPMessage = async (e) => {
        // Check if cooldown is active
      if (uploadCooldown) {
        props.setSnackInfo(
            `Please wait ${formatTimeRemaining(cooldownTimeLeft)} before uploading another file`, 
            "warning"
        );
        return;
    }
        setLoading(true);
        try {
            const { s3Link, totalAmount } = await generateAndUploadExcel(selectedPaymentData);
            setExcelLink(s3Link);
            // ── store s3Link so we can save it to DB after successful snorkel upload
            pendingS3LinkRef.current = s3Link;
            const obj = {
                email: isDK?.email,
                excellink: s3Link,
                total_so_amt: totalAmount.toFixed(2)
            };

            const response = await HttpService.sendOtpMessageToAnyEmail(obj);
            setOtpSend(true);
            // Decryption of OTP
            var bytes = CryptoJs.AES.decrypt(response.data.otp, "decorpot123");
            var decrypted_otpNumber = bytes.toString(CryptoJs.enc.Utf8);
            setOtpResponse({ otp: Number(decrypted_otpNumber) });
            ref.current?.scrollIntoView({ behavior: "smooth" });
            let focusTextFieldOtp = document.getElementById("outlined-basic1-otp");
            focusTextFieldOtp.focus();
        } catch (error) {
            props.setSnackInfo(error.response.data.msg, "error");
        }
        setLoading(false);
    };

    const verifyOTP = (e) => {
        let n = new String(e.target.value);
        if (n.length === 6 && otpResponse.otp === +e.target.value) {
            setOtpVerified(true);
        } else {
            setOtpVerified(false);
        }
    };
    const handleDateFilter = () => {
        if (!dateFilter.startDate || !dateFilter.endDate) {
            return props.setSnackInfo("Start and End Date is needed", "warning");
        }
        setPage(0);
        generateVendorPaymentSnorkelHDFC(
            0,
            rowsPerPage,
            dateFilter.startDate,
            dateFilter.endDate
        );
    };

    const handleDateFilterClear = () => {
        setDateFilter({
            startDate: "",
            endDate: ""
        });
        setPage(0);
        generateVendorPaymentSnorkelHDFC(0, rowsPerPage, "", "");
    };
const generateVendorPaymentSnorkelHDFC = async (pageNumber = 0, limit = 100,  startDateParam,endDateParam) => {
    setLoading(true);
    try {
      props.setLoading(true)
      const result = await HttpService.generateVendorPaymentSnorkelHDFCPO(pageNumber + 1, limit,startDateParam,endDateParam);
      if (result?.data?.status === "success") {
        setPaymentData(result.data.data);
        setTotalDocs(result.data.totalDocs);
        props.setSnackInfo("Data loaded..", "success");
      }else {
        setPaymentData([]);
        setTotalDocs(0);
      }
      // props.setLoading(false)
    } catch (error) {
        setPaymentData([]); 
        setTotalDocs(0);
      props.setSnackInfo(
        error?.response?.data?.message ?? "Something went wrong",
        "error"
      );
    } finally {
      setLoading(false);
     setLoadingState(false);
      props.setLoading(false)
    }
  };
   //Save Snorkel Upload Log to DB 
    const saveSnorkelUploadLog = async (s3Location, fileName) => {
        try {
            await HttpService.saveSnorkelUploadLogPO({ s3Location, fileName, uploadedBy: userDetails?._id});
        } catch (err) {
            console.error("Failed to save snorkel upload log:", err);
            // Non-blocking: don't surface error to user, just log it
        }
    };
    // Fetch past Snorkel Upload Logs
    const fetchSnorkelLogs = async () => {
        setSyncLogsLoading(true);
        try {
            const res = await HttpService.getSnorkelUploadLogsPO();
            if (res?.data?.status === "success") {
                setSnorkelLogs(res.data.data || []);
            }
        } catch (err) {
            console.error("Failed to fetch snorkel logs:", err);
        } finally {
            setSyncLogsLoading(false);
        }
    };
    // Run Sync: read Excel from selected log → update sentToBank = true
    const handleRunSync = async () => {
        if (!selectedSyncLog) {
            props.setSnackInfo("Please select an upload log to sync", "warning");
            return;
        }
        setSyncRunning(true);
        try {
            const res = await HttpService.syncSnorkelPaymentsPO({ logId: selectedSyncLog._id, s3Location: selectedSyncLog.s3Location });
            setSyncResult(res.data);
            setSyncResultModal(true);
            // Refresh the payment table after sync
            generateVendorPaymentSnorkelHDFC(page, rowsPerPage, dateFilter.startDate, dateFilter.endDate);
            props.setSnackInfo("Sync completed successfully!", "success");
        } catch (err) {
            props.setSnackInfo(err?.response?.data?.message ?? "Sync failed. Try again.", "error");
        } finally {
            setSyncRunning(false);
        }
    };

  useEffect(() => {
    generateVendorPaymentSnorkelHDFC(page, rowsPerPage);
  }, [page, rowsPerPage]);

   const openSyncModal = () => {
        setSelectedSyncLog(null);
        fetchSnorkelLogs();
        setSyncModalOpen(true);
    };

   // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    setRowsPerPage(newLimit);
    setPage(0); // reset to first page
  };

  // Helper function to start cooldown timer
    const startUploadCooldown = () => {
        const COOLDOWN_DURATION = 4 * 60 * 1000; // 4 minutes
        const cooldownEndTime = Date.now() + COOLDOWN_DURATION;
        localStorage.setItem('uploadCooldownEnd', cooldownEndTime.toString());

        const COOLDOWN_SECONDS = 240;
        
        setUploadCooldown(true);
        setCooldownTimeLeft(COOLDOWN_SECONDS);
        
        // Start countdown timer
        const interval = setInterval(() => {
            setCooldownTimeLeft(prevTime => {
                if (prevTime <= 1) {
                    setUploadCooldown(false);
                    clearInterval(interval);
                    setCooldownInterval(null);
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);
        
        setCooldownInterval(interval);
        
        // Also set a timeout as backup
        setTimeout(() => {
            setUploadCooldown(false);
            setCooldownTimeLeft(0);
            if (interval) {
                clearInterval(interval);
                setCooldownInterval(null);
            }
        }, COOLDOWN_DURATION);
    };
    
    // Helper function to format time remaining
    const formatTimeRemaining = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
    };

 // Check for existing cooldown on component mount
useEffect(() => {
    const cooldownEndTime = localStorage.getItem('uploadCooldownEnd');
    if (cooldownEndTime) {
        const remaining = parseInt(cooldownEndTime) - Date.now();
        if (remaining > 0) {
            // Resume cooldown
            const remainingSeconds = Math.ceil(remaining / 1000);
            setCooldownTimeLeft(remainingSeconds);
            setUploadCooldown(true);
            // Start timer for remaining time
        } else {
            localStorage.removeItem('uploadCooldownEnd');
        }
    }
}, []);

    // Show loader while data is loading
    if (loadingg) {
        return (
            <Typography variant="h6" style={{ marginTop: '16px', color: '#666' }}>
                Loading Please Wait....
            </Typography>

        );
    }
    const getPaymentSummary = () => {
        const totalAmount = paymentData.reduce((sum, payment) => {
            return sum + parseFloat(payment.amount || 0);
        }, 0);

        const uniqueVendors = new Set(
            paymentData.map((payment) => payment.vendorName)
        ).size;

        const paidAmount = paymentData.reduce((sum, p) => sum + parseFloat(p.paidAmount || 0), 0);
        const outstandingAmount = paymentData.reduce((sum, p) => sum + parseFloat(p.outstandingAmount || 0), 0);

        return {
            totalAmount, // number, not string
            paidAmount,
            outstandingAmount,
            totalRecords: paymentData.length,
            uniqueVendors
        };
    };
    const paymentSummary = getPaymentSummary();

    // orderId is a "/"-joined list of every PO bundled into a vendor's row — show just the
    // first and put the rest behind a tooltip so the cell doesn't stretch the table out.
    const renderOrderIdCell = (orderIdString) => {
        const orderIds = (orderIdString || "").split('/').filter(Boolean);
        if (orderIds.length === 0) return "N/A";
        if (orderIds.length === 1) return orderIds[0];
        const rest = orderIds.slice(1);
        return (
            <Tooltip title={rest.join(', ')} arrow>
                <span style={{ cursor: "default" }}>
                    {orderIds[0]}
                    <Chip
                        label={`+${rest.length}`}
                        size="small"
                        style={{ marginLeft: 6, height: 18, fontSize: "0.7rem" }}
                    />
                </span>
            </Tooltip>
        );
    };

    const handleRowSelect = (serialNo) => {
        setSelectedRows(prevSelected => {
            if (prevSelected.includes(serialNo)) {
                return prevSelected.filter(id => id !== serialNo);
            } else {
                return [...prevSelected, serialNo];
            }
        });
    };
      // Handler for select all checkbox
      const handleSelectAll = (event) => {
        if (event.target.checked) {
            const allSerialNos = paymentData.map(row => row.serialNo);
            setSelectedRows(allSerialNos);
        } else {
            setSelectedRows([]);
        }
    };

    const handleProceedDK = async () => {
        if (selectedRows.length === 0) {
            props.setSnackInfo("Please select at least one row to proceed", "warning");
            return;
        }
        if (selectedRows.length > 500) {
            props.setSnackInfo("Can not select more than 500 items at once", "warning");
            return;
        }

        const selectedData = paymentData.filter(row => 
            selectedRows.includes(row.serialNo)
        );
        
        // Store selected data in separate state for processing
        setSelectedPaymentData(selectedData);
        setDkModalOpen(true);
    };

    // helper function to create txt data to fron json.
    const createTxtData = async (data) => {
        if (!data || data.length === 0) {
            props.setSnackInfo("No data available to export", "warning");
            return null;
        }
        try {
            const lines = data.map((row) => {
                const timestampRef = moment().format('DDMMYYYYHHmmss'); // 14 chars
                const line = [
                    row.paymentType || "",                     // 1: transaction type
                    "",                                        // 2: refNo (optional)
                    row.accountNumber || "",                   // 3
                    parseFloat(row?.amount || 0).toFixed(2),    // 4
                    row?.vendorName || "",                      // 5: account holder
                    "", "", "", "", "", "", "", "", "",        // 6–14: blank
                    timestampRef,
                    row?.AllPaymentId,                         // 15-16 BankDetails for Reference
                    "", "", "", "", "", "",                   // 17–23: blank
                    row?.date,                                // 24: DD/MM/YYYY
                    "",                                         // 25: blank
                    row?.ifsc || "",                            // 26
                    row?.bankName || "",                        // 27
                    "",                                        // 28: Branch name (not available)
                    row?.email || ""                            // 29: Optional
                ].join(",");
                return line;
            });
            const content = lines.join("\n");
            return new Blob([content], { type: "text/plain" });
        } catch (error) {
            console.error("Error generating TXT file:", error);
            return null;
        }
    };

// test H2HCBX , prod SAMIKACX ……
// Helper function to generate SRL filename
const generateFileName = (file,Domain = "SAMIKACX" ,clientCode = '5620') => {
    const now = moment();
    const dayMonth = now.format('DDMM'); // Format: DDMM
    // Milliseconds since start of day
    const msOfDay = now.diff(now.clone().startOf('day'), 'milliseconds');
    // 3 minutes in milliseconds
    const interval = 3 * 60 * 1000;
    // Interval index in the day → will always be unique for each 3-min slot
    const slotNumber = Math.floor(msOfDay / interval) % 1000; // keep in 3 digits
    const srlNumber = slotNumber.toString().padStart(3, '0');
    const extension = '.txt';

    return `${Domain}_${clientCode}_${clientCode}${dayMonth}.${srlNumber}${extension}`;
};

// prod
// File Naming Convention: DomainID_ClientCode_ClientCodeDDMM.3DigitSerialNumber  
// Domain: SAMIKACX  
// Client Code: 5620 
// Example: SAMIKACX_5620_56200108.437  

// test/staging
// File Naming Convention: DomainID_ClientCode_ClientCodeDDMM.3DigitSerialNumber  
// Domain: H2HCBX  
// Client Code: SRBI 
// Example: H2HCBX_SRBI_SRBI0108.437 

// Helper function to chunk array into batches
const chunkArray = (array, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
};    
// after this function call the file goes to snorkell for payment
const FinalApprovalFlowByDKFunction = async () => {
    if (selectedPaymentData.length === 0) {
        props.setSnackInfo("No payment data to send for approval", "error");
        return;
    }
    try {
        setApprovalLoading(true);
        setShowProgressModal(true);
        setCanCloseModal(false);
        setProcessingMessage("Please wait processing is going on......");
        setProcessingProgress(10);
        // Generate TXT file
        const formatedTxtData = await createTxtData(selectedPaymentData);
         // console.log("formatedTxtData", formatedTxtData);
        if (!formatedTxtData) {
            props.setSnackInfo("Failed to generate TXT file", "error");
            return;
        }

        const fileName = generateFileName(null);
         // console.log("fileName", fileName);
        const formData = new FormData();
        formData.append("file", formatedTxtData, fileName)
        setProcessingMessage("Uploading file please wait...");
        setProcessingProgress(50);

        // Upload to S3
        const uploadResponse = await HttpService.uploadToS3ForSnorkelPaymentPO(formData);
        
        if (!uploadResponse?.data?.success) {
            props.setSnackInfo("Failed to upload file to S3", "error");
            return;
        }

        const s3Location = uploadResponse?.data?.s3Location;
        if (!s3Location) {
            props.setSnackInfo("S3 location not received from upload", "error");
            return;
        }
        // ── NEW: save the Excel s3Link (from WhatsApp OTP) to SnorkelUploadLogs
        if (pendingS3LinkRef.current) {
            await saveSnorkelUploadLog(pendingS3LinkRef.current, fileName);
            pendingS3LinkRef.current = null; // clear after saving
            // Refresh sync panel logs
            fetchSnorkelLogs();
        }
        

        startUploadCooldown();
        setProcessingProgress(100);
        setProcessingMessage("File uploaded to Snorkel successfully!");
        setCanCloseModal(true);
        props.setSnackInfo("File sent to Snorkel successfully!", "success");
        setSelectedPaymentData([]);
        setSelectedRows([]);
        // Refresh the payment table after successful upload
        generateVendorPaymentSnorkelHDFC(page, rowsPerPage, dateFilter.startDate, dateFilter.endDate);

    } catch (error) {
        console.error(error);
        setProcessingMessage("Processing failed!");
        setCanCloseModal(true);
        props.setSnackInfo(
            error?.response?.data?.message ?? "Failed to send. Try again after some time.",
            "error"
        );
    } finally {
        setApprovalLoading(false);
    }
};

const fmtINR = (n) =>
    Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const handleEditClick = async (row) => {
    setEditRow(row);
    setEditModalOpen(true);
    setEditLoading(true);
    setEditPayments([]);
    setEditRemark("");
    setEditAmount("");
    try {
        const response = await HttpService.getPaymentRequestBreakdownPO(row.vendorId);
        if (response?.data?.success) {
            const { payments, totals } = response.data.data;
            setEditPayments(payments);
            setEditTotals(totals);
            // pre-fill with what is currently going to be paid for this vendor
            setEditAmount(String(totals.payNowAmount));
        }
    } catch (error) {
        console.error(error);
        props.setSnackInfo(
            error?.response?.data?.message ?? "Failed to load payment details",
            "error"
        );
        setEditModalOpen(false);
    } finally {
        setEditLoading(false);
    }
};

// One amount for the whole vendor: must be > 0 and can't exceed everything still outstanding.
const isEditAmountInvalid = () => {
    const amount = parseFloat(editAmount);
    if (isNaN(amount) || amount <= 0) return true;
    return amount > editTotals.remainingAmount + 0.01;
};

const getEditAmountHelper = () => {
    const amount = parseFloat(editAmount);
    if (editAmount === "" || isNaN(amount) || amount <= 0) return "Enter an amount greater than 0";
    if (amount > editTotals.remainingAmount + 0.01) return `Cannot exceed ₹${fmtINR(editTotals.remainingAmount)}`;
    return `Outstanding after this payment: ₹${fmtINR(Math.max(0, editTotals.remainingAmount - amount))}`;
};

const downloadEditPaymentsExcel = () => {
    try {
        const exportData = editPayments.map((payment, index) => ({
            "Sl No": index + 1,
            "PO Order ID": payment.orderId || "N/A",
            "Invoice No.": payment.invoiceNumber || "N/A",
            "Approved By": payment.raisedBy || "N/A",
            "Approved At": payment.raisedAt ? moment(payment.raisedAt).format("DD/MM/YYYY") : "N/A",
            "Inwarded Qty": payment.inwardedQty,
            "Inwarded Rate": payment.inwardedRate,
            "Inwarded Value": payment.inwardedValue,
            "GST %": payment.gstRate,
            "GST Amount": payment.gstAmount,
            "Freight": payment.freightCharge,
            "Total Payable": payment.payableAmount,
            "Paid": payment.paidAmount,
            "Outstanding": payment.remainingAmount,
        }));
        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Payments");
        XLSX.writeFile(wb, `Invoice.xlsx`);
    } catch (err) {
        console.error(err.message);
        props.setSnackInfo("Something went wrong while downloading excel", "error");
    }
};

const handleEditSave = async () => {
    if (!editRow || editPayments.length === 0) return;
    if (isEditAmountInvalid()) {
        props.setSnackInfo("Amount must be greater than 0 and not exceed the outstanding amount", "error");
        return;
    }
    if (!editRemark.trim()) {
        props.setSnackInfo("Remark is required", "error");
        return;
    }
    setEditSaving(true);
    try {
        const response = await HttpService.updatePaymentRequestBreakdownPO(
            editRow.vendorId,
            { remark: editRemark, amount: parseFloat(editAmount) }
        );
        if (response?.data?.success) {
            props.setSnackInfo("Payment amount updated successfully", "success");
            setEditModalOpen(false);
            // bank-file tokens (per-record amounts) change with the edit, so reload the list
            generateVendorPaymentSnorkelHDFC(page, rowsPerPage, dateFilter.startDate, dateFilter.endDate);
        }
    } catch (error) {
        console.error(error);
        props.setSnackInfo(
            error?.response?.data?.message ?? "Failed to update payment details",
            "error"
        );
    } finally {
        setEditSaving(false);
    }
};

// excel download section — same column order as the table
const csvHeaders = [
  { label: "SL No", key: "serialNo" },
  { label: "Type", key: "paymentType" },
  { label: "Vendor Name", key: "vendorName" },
  { label: "Order ID", key: "orderId" },
  { label: "Email", key: "email" },
  { label: "Date", key: "date" },
  { label: "Amount (Pay Now)", key: "amount" },
  { label: "Paid", key: "paidAmount" },
  { label: "Outstanding", key: "outstandingAmount" },
  { label: "Bank", key: "bankName" },
  { label: "IFSC", key: "ifsc" },
  { label: "Account No", key: "accountNumber" },
];

const statCards = [
    { label: "Amount to Pay Now", value: `₹${fmtINR(paymentSummary.totalAmount)}`, color: "#2563eb", bg: "#eff6ff", Icon: PaymentIcon },
    { label: "Paid So Far", value: `₹${fmtINR(paymentSummary.paidAmount)}`, color: "#059669", bg: "#ecfdf5", Icon: CheckCircleIcon },
    { label: "Outstanding", value: `₹${fmtINR(paymentSummary.outstandingAmount)}`, color: "#b45309", bg: "#fffbeb", Icon: PendingIcon },
    { label: "Vendors / Records", value: `${paymentSummary.uniqueVendors} / ${paymentSummary.totalRecords}`, color: "#7c3aed", bg: "#f5f3ff", Icon: BusinessIcon },
];

const tableColumns = [
    { label: "SL" }, { label: "Type" }, { label: "Vendor Name" },
    { label: "Order ID" }, { label: "Email" }, { label: "Date" },
    { label: "Pay Now (₹)", bg: "#2563eb", align: "right", width: 120 },
    { label: "Paid (₹)", bg: "#059669", align: "right", width: 110 },
    { label: "Outstanding (₹)", bg: "#b45309", align: "right", width: 130 },
    { label: "Bank" }, { label: "IFSC" }, { label: "Account No" },
    { label: "Edit", align: "center" },
];
// payment rail: I = HDFC (internal), N = NEFT (< 2L), R = RTGS
const paymentTypeMeta = {
    I: { label: "HDFC internal transfer", bg: "#dbeafe", color: "#1d4ed8" },
    N: { label: "NEFT", bg: "#dcfce7", color: "#15803d" },
    R: { label: "RTGS", bg: "#fef3c7", color: "#b45309" },
};
const thStyle = { backgroundColor: "#1e293b", color: "#fff", fontWeight: 700, fontSize: "0.78rem", letterSpacing: 0.4, textTransform: "uppercase", whiteSpace: "nowrap", padding: "12px 12px" };
const tdStyle = { fontSize: "0.85rem", padding: "10px 12px", borderBottom: "1px solid #eef2f7" };
const amountPill = { display: "inline-block", padding: "3px 10px", borderRadius: 999, fontWeight: 700, fontVariantNumeric: "tabular-nums" };

const cardStyle = { borderRadius: 14, boxShadow: "0 4px 20px rgba(15,23,42,0.07)", border: "1px solid #e2e8f0" };

return (
    <div style={{ background: "#f8fafc", minHeight: "100vh", paddingBottom: 32 }}>
        <Container maxWidth="xl" style={{ paddingTop: 24 }}>
            {/* Page header */}
            <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" style={{ gap: 12, marginBottom: 20 }}>
                <Box>
                    <Typography variant="h5" style={{ fontWeight: 800, color: "#0f172a" }}>
                        Vendor PO Payments
                    </Typography>
                    <Typography variant="body2" style={{ color: "#64748b" }}>
                        Pay approved PO inwardings in full or in parts — a line stays here until it is fully paid.
                    </Typography>
                </Box>
                <Box display="flex" style={{ gap: 10 }}>
                    <Button
                        variant="outlined"
                        onClick={openSyncModal}
                        startIcon={<SyncIcon />}
                        style={{ height: 40, fontSize: 13, textTransform: "none", fontWeight: 600, borderRadius: 10, borderColor: "#2563eb", color: "#2563eb", background: "#fff" }}
                    >
                        Sync Payments
                    </Button>
                    <CSVLink
                        data={paymentData || []}
                        headers={csvHeaders}
                        filename={"VendorPayments.csv"}
                        style={{ textDecoration: "none" }}
                    >
                        <Button
                            variant="contained"
                            startIcon={<DownloadIcon />}
                            style={{ height: 40, fontSize: 13, textTransform: "none", fontWeight: 600, borderRadius: 10, backgroundColor: "#0f172a", color: "#fff" }}
                        >
                            Download CSV
                        </Button>
                    </CSVLink>
                </Box>
            </Box>

            {/* Summary cards */}
            <Grid container spacing={2} style={{ marginBottom: 20 }}>
                {statCards.map(({ label, value, color, bg, Icon }) => (
                    <Grid item xs={12} sm={6} md={3} key={label}>
                        <Card style={{ ...cardStyle, borderLeft: `5px solid ${color}` }}>
                            <CardContent style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <Box>
                                    <Typography variant="body2" style={{ color: "#64748b", fontWeight: 600 }}>
                                        {label}
                                    </Typography>
                                    <Typography variant="h5" style={{ fontWeight: 800, color }}>
                                        {value}
                                    </Typography>
                                </Box>
                                <Box style={{ background: bg, color, borderRadius: 12, padding: 10, display: "flex" }}>
                                    <Icon />
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {/* Date filter */}
            <Paper elevation={0} style={{ ...cardStyle, padding: "12px 16px", marginBottom: 20 }}>
                <Grid container spacing={2} alignItems="flex-end">
                    <Grid item xs={12} sm={3} md={2}>
                        <TextField
                            label="From Date"
                            type="date"
                            name="startDate"
                            value={dateFilter.startDate}
                            onChange={handleDateChange}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} md={2}>
                        <TextField
                            label="To Date"
                            type="date"
                            name="endDate"
                            value={dateFilter.endDate}
                            onChange={handleDateChange}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box display="flex" style={{ gap: 8 }}>
                            <Button
                                variant="contained"
                                onClick={handleDateFilter}
                                style={{ backgroundColor: "#2563eb", color: "#fff", height: 38, borderRadius: 8, textTransform: "none", fontWeight: 600 }}
                            >
                                Filter
                            </Button>
                            <Button
                                variant="outlined"
                                onClick={handleDateFilterClear}
                                style={{ borderColor: "#dc2626", color: "#dc2626", height: 38, borderRadius: 8, textTransform: "none", fontWeight: 600 }}
                            >
                                Clear
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>

            {/* Table Section */}
            <Card style={cardStyle}>
                <CardContent>
                    <TableContainer component={Paper} elevation={0} style={{ maxHeight: 800, border: "1px solid #e2e8f0", borderRadius: 12 }}>
                        <Table stickyHeader size="small" style={{ minWidth: 1300 }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell padding="checkbox" style={{ ...thStyle, paddingLeft: 8 }}>
                                        <Checkbox
                                            checked={selectedRows.length === paymentData.length && paymentData.length > 0}
                                            indeterminate={selectedRows.length > 0 && selectedRows.length < paymentData.length}
                                            onChange={handleSelectAll}
                                            style={{ color: "#fff" }}
                                        />
                                    </TableCell>
                                    {tableColumns.map((col) => (
                                        <TableCell
                                            key={col.label}
                                            align={col.align || "left"}
                                            style={{ ...thStyle, ...(col.bg ? { backgroundColor: col.bg } : {}), ...(col.width ? { minWidth: col.width } : {}) }}
                                        >
                                            {col.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {paymentData.map((row, index) => {
                                    const type = paymentTypeMeta[row.paymentType] || { label: row.paymentType, bg: "#e2e8f0", color: "#334155" };
                                    const isSelected = selectedRows.includes(row.serialNo);
                                    const hasPaid = Number(row.paidAmount) > 0;
                                    return (
                                        <TableRow
                                            key={index}
                                            hover
                                            selected={isSelected}
                                            style={{ backgroundColor: isSelected ? "#eff6ff" : index % 2 ? "#f8fafc" : "#fff" }}
                                        >
                                            <TableCell padding="checkbox" style={{ ...tdStyle, paddingLeft: 8 }}>
                                                <Checkbox
                                                    checked={isSelected}
                                                    onChange={() => handleRowSelect(row.serialNo)}
                                                    style={{ color: isSelected ? "#2563eb" : undefined }}
                                                />
                                            </TableCell>
                                            <TableCell style={{ ...tdStyle, color: "#94a3b8", fontWeight: 600 }}>{row.serialNo}</TableCell>
                                            <TableCell style={tdStyle}>
                                                <Tooltip title={type.label} arrow>
                                                    <Chip
                                                        label={row.paymentType}
                                                        size="small"
                                                        style={{ backgroundColor: type.bg, color: type.color, fontWeight: 700, minWidth: 28 }}
                                                    />
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell style={{ ...tdStyle, fontWeight: 700, color: "#0f172a", minWidth: 200 }}>
                                                {row.vendorName}
                                            </TableCell>
                                            <TableCell style={{ ...tdStyle, fontFamily: "monospace", whiteSpace: "nowrap", maxWidth: 260, overflow: "hidden", textOverflow: "ellipsis" }}>
                                                {renderOrderIdCell(row.orderId)}
                                            </TableCell>
                                            <TableCell style={{ ...tdStyle, color: "#475569" }}>{row.email || "—"}</TableCell>
                                            <TableCell style={{ ...tdStyle, color: "#475569", whiteSpace: "nowrap" }}>{row.date}</TableCell>
                                            <TableCell align="right" style={tdStyle}>
                                                <span style={{ ...amountPill, background: "#eff6ff", color: "#1d4ed8" }}>{fmtINR(row.amount)}</span>
                                            </TableCell>
                                            <TableCell align="right" style={tdStyle}>
                                                <span style={{ ...amountPill, background: hasPaid ? "#ecfdf5" : "transparent", color: hasPaid ? "#047857" : "#94a3b8" }}>
                                                    {fmtINR(row.paidAmount)}
                                                </span>
                                            </TableCell>
                                            <TableCell align="right" style={tdStyle}>
                                                <span style={{ ...amountPill, background: "#fffbeb", color: "#b45309" }}>{fmtINR(row.outstandingAmount)}</span>
                                            </TableCell>
                                            <TableCell style={{ ...tdStyle, minWidth: 130 }}>{row.bankName || "—"}</TableCell>
                                            <TableCell style={{ ...tdStyle, fontFamily: "monospace", whiteSpace: "nowrap" }}>{row.ifsc}</TableCell>
                                            <TableCell style={{ ...tdStyle, fontFamily: "monospace", whiteSpace: "nowrap" }}>{row.accountNumber}</TableCell>
                                            <TableCell align="center" style={tdStyle}>
                                                <Tooltip title="Edit payment amount">
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => handleEditClick(row)}
                                                        style={{ background: "#f1f5f9", color: "#2563eb" }}
                                                    >
                                                        <EditIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                                {paymentData.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={14} align="center" style={{ padding: 40, color: "#94a3b8" }}>
                                            No pending vendor payments
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {/* Action Button */}
                    <Box mt={3} display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="body2" color="textSecondary">
                            {selectedRows.length} of {paymentData.length} rows selected
                        </Typography>
                        <Button
                            variant="contained"
                            onClick={handleProceedDK}
                            disabled={selectedRows.length <= 0 || approvalLoading || uploadCooldown}
                            startIcon={approvalLoading ? <Oval size={20} color="inherit" /> : ''}
                            sx={{
                                backgroundColor: "#2563eb",
                                '&:hover': {
                                    backgroundColor: "#1d4ed8"
                                },
                                '&.Mui-disabled': {
                                    cursor: 'not-allowed',
                                    pointerEvents: 'auto',
                                },
                                color: "#fff",
                                textTransform: "none",
                                borderRadius: 2,
                                px: 3,
                                py: 1
                            }}
                        >
                            {approvalLoading
                                ? "Processing..."
                                : uploadCooldown
                                    ? `Wait ${formatTimeRemaining(cooldownTimeLeft)}`
                                    : `Process Selected (${selectedRows.length})`
                            }
                        </Button>
                    </Box>
                     <TablePagination
                component="div"
                count={totalDocs}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[100, 200, 300, 500]}
            />
                </CardContent>
            </Card>
        </Container>
            <Dialog open={syncModalOpen} onClose={() => setSyncModalOpen(false)} maxWidth="sm" fullWidth
                PaperProps={{ style: { borderRadius: 16 } }}>
                <DialogTitle>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box display="flex" alignItems="center" style={{ gap: 10 }}>
                            <SyncIcon style={{ color: "#2563eb" }} />
                            <Typography variant="h6" style={{ fontWeight: 700 }}>Sync Payments to ERP</Typography>
                        </Box>
                        <IconButton onClick={() => setSyncModalOpen(false)} size="small">
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Typography variant="body2" color="textSecondary" style={{ marginTop: 4 }}>
                        Select a past Snorkel upload and run sync to mark those payments to synced in ERP.
                    </Typography>
                </DialogTitle>
 
                <DialogContent dividers>
                    {syncLogsLoading ? (
                        <Box display="flex" alignItems="center" justifyContent="center" py={4} style={{ gap: 12 }}>
                            <Oval color="#2563eb" height={24} width={24} />
                            <Typography color="textSecondary">Loading upload history...</Typography>
                        </Box>
                    ) : snorkelLogs.length === 0 ? (
                        <Box display="flex" alignItems="center" justifyContent="center" py={4}
                            style={{ border: "1px dashed #cbd5e1", borderRadius: 10 }}>
                            <Typography color="textSecondary" variant="body2">
                                No upload logs found. Logs appear here after a successful Snorkel upload.
                            </Typography>
                        </Box>
                    ) : (
                        <Box style={{ maxHeight: 320, overflowY: "auto", display: "flex", flexDirection: "column", gap: 8 }}>
                            {snorkelLogs.map((log, idx) => {
                                const isSelected = selectedSyncLog?._id === log._id;
                                return (
                                    <Box
                                        key={log._id || idx}
                                        onClick={() => setSelectedSyncLog(isSelected ? null : log)}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            padding: "12px 16px",
                                            borderRadius: 10,
                                            border: `2px solid ${isSelected ? "#2563eb" : "#e2e8f0"}`,
                                            background: isSelected ? "#eff6ff" : "#f8fafc",
                                            cursor: "pointer",
                                            transition: "all 0.18s",
                                        }}
                                    >
                                        <Box display="flex" alignItems="center" style={{ gap: 12 }}>
                                            {/* Radio dot */}
                                            <Box style={{
                                                width: 16, height: 16, borderRadius: "50%",
                                                border: `2px solid ${isSelected ? "#2563eb" : "#94a3b8"}`,
                                                background: isSelected ? "#2563eb" : "transparent",
                                                flexShrink: 0, transition: "all 0.2s",
                                            }} />
                                            <Box>
                                                <Typography variant="body2" style={{ fontWeight: 600, color: "#1e293b" }}>
                                                    Upload #{snorkelLogs.length - idx}
                                                </Typography>
                                                <Typography variant="caption" color="textSecondary">
                                                    {moment(log.uploadedAt).format("DD MMM YYYY, hh:mm A")} {" | "}
                                                    Uploaded by : {log.uploadedBy?.name ? ` ${log.uploadedBy.name}` : ""}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                                            <Chip
                                                label={log.syncedAt ? "Synced" : "Pending"}
                                                size="small"
                                                style={{
                                                    fontWeight: 600, fontSize: "0.75rem",
                                                    backgroundColor: log.syncedAt ? "#dcfce7" : "#fef9c3",
                                                    color: log.syncedAt ? "#16a34a" : "#a16207",
                                                }}
                                            />
                                            <Tooltip title={log.s3Location ? "Download uploaded file" : "No file available"}>
                                                <span>
                                                    <IconButton
                                                        size="small"
                                                        component="a"
                                                        href={log.s3Location}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        download
                                                        disabled={!log.s3Location}
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        <DownloadIcon fontSize="small" />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                        </Box>
                                    </Box>
                                );
                            })}
                        </Box>
                    )}
 
                    {selectedSyncLog && (
                        <Box mt={2} p={1.5} style={{ background: "#eff6ff", borderRadius: 8, border: "1px solid #bfdbfe" }}>
                            <Typography variant="body2" style={{ color: "#1d4ed8" }}>
                                ✅ Upload from <strong>{moment(selectedSyncLog.uploadedAt).format("DD MMM YYYY, hh:mm A")}</strong> selected.
                                Clicking <strong>Run Sync</strong> will mark all matching orders as synced in ERP.
                            </Typography>
                        </Box>
                    )}
                </DialogContent>
 
                <DialogActions style={{ padding: "16px 24px", gap: 8 }}>
                    <Button onClick={fetchSnorkelLogs} disabled={syncLogsLoading}
                        startIcon={<SyncIcon style={{ fontSize: 16 }} />}
                        style={{ textTransform: "none", color: "#64748b" }}>
                        {syncLogsLoading ? "Refreshing..." : "Refresh"}
                    </Button>
                    <Box flex={1} />
                    <Button onClick={() => setSyncModalOpen(false)} style={{ textTransform: "none" }}>
                        Cancel
                    </Button>
                    <Button
                        onClick={handleRunSync}
                        disabled={!selectedSyncLog || syncRunning}
                        variant="contained"
                        startIcon={syncRunning ? <Oval color="#fff" height={16} width={16} /> : <CloudUploadIcon />}
                        style={{
                            backgroundColor: (!selectedSyncLog || syncRunning) ? "#e2e8f0" : "#2563eb",
                            color: (!selectedSyncLog || syncRunning) ? "#94a3b8" : "#fff",
                            textTransform: "none", fontWeight: 600, borderRadius: 8,
                        }}
                    >
                        {syncRunning ? "Syncing..." : "Run Sync"}
                    </Button>
                </DialogActions>
            </Dialog>
            {/* SYNC RESULT MODAL */}
            <Dialog open={syncResultModal} onClose={() => setSyncResultModal(false)} maxWidth="xs" fullWidth
                PaperProps={{ style: { borderRadius: 16 } }}>
                <DialogTitle>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6" style={{ fontWeight: 700 }}>Sync Complete</Typography>
                        <IconButton onClick={() => setSyncResultModal(false)} size="small"><CloseIcon /></IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    {syncResult && (
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Box style={{ background: "#dcfce7", borderRadius: 12, padding: 16, textAlign: "center" }}>
                                    <Typography style={{ color: "#16a34a", fontSize: "2rem", fontWeight: 700 }}>
                                        {syncResult.summary?.updatedCount ?? syncResult.updatedCount ?? "—"}
                                    </Typography>
                                    <Typography variant="caption" color="textSecondary">Orders Updated</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                <Box style={{ background: "#fef9c3", borderRadius: 12, padding: 16, textAlign: "center" }}>
                                    <Typography style={{ color: "#a16207", fontSize: "2rem", fontWeight: 700 }}>
                                        {syncResult.summary?.skippedCount ?? syncResult.skippedCount ?? "—"}
                                    </Typography>
                                    <Typography variant="caption" color="textSecondary">Skipped / Not Found</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="body2" color="textSecondary" style={{ marginTop: 4 }}>
                                    {syncResult.message || "Matching service orders have been marked in ERP."}
                                </Typography>
                            </Grid>
                        </Grid>
                    )}
                </DialogContent>
                <DialogActions style={{ padding: "16px 24px" }}>
                    <Button onClick={() => { setSyncResultModal(false); setSyncModalOpen(false); }} variant="contained" color="primary"
                        style={{ textTransform: "none", borderRadius: 8 }}>Done</Button>
                </DialogActions>
            </Dialog>
            {dkModalOpen && (
                <Dialog
                    open={dkModalOpen}
                    onClose={() => {
                        setDkModalOpen(false);
                        setOtpResponse([]);
                        setOtpSend(false);     // reset back to email send screen
                        setOtpVerified(false); // reset verification state
                    }}

                    maxWidth="sm"
                    fullWidth
                    PaperProps={{
                        style: {
                            borderRadius: 20,
                            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
                            overflow: "hidden",
                        },
                    }}
                >
                    <DialogTitle style={{ padding: 0 }}>
                        <Box
                            style={{
                                background: "rgba(255, 255, 255, 0.1)",
                                backdropFilter: "blur(10px)",
                                padding: "24px",
                                color: "white",
                            }}
                        >
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <Box display="flex" alignItems="center">
                                    <Box
                                        style={{
                                            background: "rgba(255, 255, 255, 0.2)",
                                            borderRadius: "50%",
                                            padding: "12px",
                                            marginRight: "16px",
                                        }}
                                    >
                                        <EmailIcon style={{ fontSize: 28, color: "white" }} />
                                    </Box>
                                    <Box>
                                        <Typography
                                            variant="h5"
                                            style={{ fontWeight: 700, marginBottom: 4 }}
                                        >
                                            OTP Verification
                                        </Typography>
                                        <Typography variant="body2" style={{ opacity: 0.9 }}>
                                            Verify your identity to proceed
                                        </Typography>
                                    </Box>
                                </Box>
                                <IconButton
                                    // onClick={() => setDkModalOpen(false)}
                                    onClick={() => {
                                        setDkModalOpen(false);
                                        setOtpResponse([]);
                                        setOtpSend(false);    
                                        setOtpVerified(false); 
                                    }}

                                    style={{ color: "rgba(255, 255, 255, 0.8)" }}
                                    disabled={approvalLoading} // Disable close during processing
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                        </Box>
                    </DialogTitle>
                    <DialogContent style={{ padding: "32px", background: "white" }}>
                        <Box display="flex" justifyContent="center" marginBottom={3}>
                            <Box
                                style={{
                                    background:
                                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                    borderRadius: "50%",
                                    padding: "20px",
                                }}
                            >
                                <EmailIcon style={{ fontSize: 40, color: "white" }} />
                            </Box>
                        </Box>
                        {!otpSend ? (
                            // Send OTP Section
                            <Box textAlign="center">
                                <Typography
                                    variant="h6"
                                    style={{
                                        marginBottom: 24,
                                        color: "#1e293b",
                                        fontWeight: 600,
                                    }}
                                >
                                    Send Verification Code
                                </Typography>
                                <Box
                                    style={{
                                        background:
                                            "linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)",
                                        padding: "20px",
                                        borderRadius: 12,
                                        marginBottom: 24,
                                    }}
                                >
                                    <Typography
                                        variant="body1"
                                        style={{ color: "#64748b", marginBottom: 16 }}
                                    >
                                        We'll send a verification code to:
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        style={{ color: "#1e293b", fontWeight: 600 }}
                                    >
                                        {/* 📧 {userDetails?.email} */}
                                        {/* 📧 dk1@decorpot.com */}
                                        📧 {isDK?.email}
                                    </Typography>
                                </Box>
                                <Button
                                    onClick={setOTPMessage}
                                    variant="contained"
                                    disabled={loading || approvalLoading}
                                    startIcon={
                                        loading ? (
                                            <Oval color="white" height={20} width={20} />
                                        ) : (
                                            <SendIcon />
                                        )
                                    }
                                    style={{
                                        background:
                                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                        color: "white",
                                        fontWeight: 700,
                                        borderRadius: 12,
                                        textTransform: "none",
                                        padding: "12px 32px",
                                        fontSize: "16px",
                                        boxShadow: "0 10px 15px -3px rgba(103, 126, 234, 0.4)",
                                        width: "100%",
                                    }}
                                >
                                    {loading ? "Sending..." : "Send OTP"}
                                </Button>
                            </Box>
                        ) : (
                            // Verify OTP Section
                            <Box>
                                <Typography
                                    variant="h6"
                                    align="center"
                                    style={{
                                        marginBottom: 24,
                                        color: "#1e293b",
                                        fontWeight: 600,
                                    }}
                                >
                                    Enter Verification Code
                                </Typography>
                                <TextField
                                    id="outlined-basic1-otp"
                                    label="Enter 6-digit OTP"
                                    variant="outlined"
                                    fullWidth
                                    onChange={verifyOTP}
                                    disabled={approvalLoading} // Disable input during processing
                                    inputProps={{
                                        maxLength: 6,
                                        style: {
                                            fontSize: "18px",
                                            textAlign: "center",
                                            letterSpacing: "0.5em",
                                        },
                                    }}
                                    style={{ marginBottom: 24 }}
                                    InputProps={{
                                        style: {
                                            borderRadius: 12,
                                            background: "#f8fafc",
                                        },
                                    }}
                                    InputLabelProps={{
                                        style: { color: "#64748b" },
                                    }}
                                />
                                {otpVerified && !approvalLoading && (
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        style={{
                                            background: "rgba(34, 197, 94, 0.1)",
                                            color: "#059669",
                                            padding: "12px",
                                            borderRadius: 12,
                                            marginBottom: 16,
                                        }}
                                    >
                                        <CheckCircleIcon style={{ marginRight: 8, fontSize: 20 }} />
                                        <Typography variant="body2" style={{ fontWeight: 600 }}>
                                            OTP Verified Successfully!
                                        </Typography>
                                    </Box>
                                )}
                                {approvalLoading && (
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        style={{
                                            background: "rgba(59, 130, 246, 0.1)",
                                            color: "#2563eb",
                                            padding: "12px",
                                            borderRadius: 12,
                                            marginBottom: 16,
                                        }}
                                    >
                                        <Oval color="#2563eb" height={20} width={20} style={{ marginRight: 8 }} />
                                        <Typography variant="body2" style={{ fontWeight: 600 }}>
                                            Processing approval request...
                                        </Typography>
                                    </Box>
                                )}

                                <Box
                                    style={{
                                        background: "rgba(103, 126, 234, 0.1)",
                                        borderRadius: 12,
                                        padding: "16px",
                                        border: "1px solid rgba(103, 126, 234, 0.2)",
                                    }}
                                >
                                    <Typography
                                        variant="body2"
                                        style={{ color: "#475569", textAlign: "center" }}
                                    >
                                        💡 Check your E-Mail for the 6-digit verification code
                                    </Typography>
                                </Box>
                            </Box>
                        )}
                    </DialogContent>
                    <DialogActions style={{ padding: "24px", background: "#f8fafc" }}>
                        {otpSend && (
                            <Button
                                onClick={async () => {
                                    if (otpVerified && !approvalLoading) {
                                        try {
                                            await FinalApprovalFlowByDKFunction();
                                            setDkModalOpen(false);
                                            setOtpResponse([]);
                                            setOtpVerified(false);
                                            setOtpSend(false);
                                            setModalOpen(false);
                                        } catch (error) {
                                            console.error("Error in final approval flow:", error);
                                        }
                                    }
                                }}
                                variant="contained"
                                disabled={!otpVerified || approvalLoading}
                                startIcon={
                                    approvalLoading ? (
                                        <Oval color="white" height={20} width={20} />
                                    ) : (
                                        <SendIcon />
                                    )
                                }
                                style={{
                                    background: (otpVerified && !approvalLoading)
                                        ? "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)"
                                        : "#e2e8f0",
                                    color: (otpVerified && !approvalLoading) ? "white" : "#94a3b8",
                                    fontWeight: 700,
                                    borderRadius: 12,
                                    textTransform: "none",
                                    padding: "12px 32px",
                                    boxShadow: (otpVerified && !approvalLoading)
                                        ? "0 10px 15px -3px rgba(34, 197, 94, 0.4)"
                                        : "none",
                                }}
                            >
                                {approvalLoading ? "Processing..." : "Proceed"}
                            </Button>
                        )}
                    </DialogActions>
                </Dialog>
            )}
            {/*  this message is showing the progress bar for payment success and fail. */}
            {showProgressModal && (
                <Dialog
                    open={showProgressModal}
                    onClose={canCloseModal ? () => setShowProgressModal(false) : undefined}
                    maxWidth="xs"
                    fullWidth
                    PaperProps={{
                        style: {
                            borderRadius: 20,
                            padding: 24,
                            background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
                            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
                        }
                    }}
                >
                    <DialogTitle>
                        <Typography variant="h6" fontWeight={700}>
                            Processing Payments
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <Box>
                            <LinearProgress
                                variant="determinate"
                                value={processingProgress}
                                sx={{
                                    height: 10,
                                    borderRadius: 5,
                                    backgroundColor: "#e2e8f0",
                                    "& .MuiLinearProgress-bar": {
                                        backgroundColor: "#667eea",
                                    },
                                }}
                            />
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                align="center"
                                sx={{ mt: 2, mb: 1 }}
                            >
                                {processingProgress.toFixed(0)}% Complete
                            </Typography>
                            <Typography
                                variant="body2"
                                align="center"
                                sx={{ mb: 2, color: "#334155" }}
                            >
                                {processingMessage}
                            </Typography>
                            {!canCloseModal && (
                                <Typography
                                    variant="caption"
                                    color="textSecondary"
                                    align="center"
                                    display="block"
                                    sx={{ fontStyle: "italic" }}
                                >
                                    Please don't close this window or press back. Processing will complete automatically.
                                </Typography>
                            )}
                            {canCloseModal && (
                                <Button
                                    onClick={() => setShowProgressModal(false)}
                                    variant="contained"
                                    fullWidth
                                    style={{
                                        background:
                                            "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
                                        color: "white",
                                        fontWeight: 700,
                                        marginTop: 24,
                                        borderRadius: 12,
                                        textTransform: "none",
                                    }}
                                >
                                    Close
                                </Button>
                            )}
                        </Box>
                    </DialogContent>
                </Dialog>
            )}
                        {editModalOpen && (
                <Dialog
                    open={editModalOpen}
                    onClose={() => !editSaving && setEditModalOpen(false)}
                    maxWidth="lg"
                    fullWidth
                    PaperProps={{ style: { borderRadius: 16 } }}
                >
                    <DialogTitle style={{ background: "linear-gradient(135deg, #1e293b 0%, #334155 100%)", color: "#fff" }}>
                        <Typography variant="h6" style={{ fontWeight: 800 }}>Edit Payment Details</Typography>
                        {editRow && (
                            <Typography variant="body2" style={{ color: "#cbd5e1" }}>
                                Vendor: <strong>{editRow.vendorName}</strong> &nbsp;|&nbsp; Orders: {editRow.orderId}
                            </Typography>
                        )}
                    </DialogTitle>
                    <DialogContent dividers>
                        {editLoading ? (
                            <Box display="flex" justifyContent="center" py={4}>
                                <Oval color="#2563eb" height={30} width={30} />
                            </Box>
                        ) : (
                            <>
                                <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
                                    Pending PO inwarding records. Enter one amount below to pay now — it is applied oldest-first.
                                </Typography>
                                <TableContainer component={Paper} variant="outlined" style={{ marginBottom: 16, maxHeight: 340 }}>
                                    <Table size="small" stickyHeader>
                                        <TableHead>
                                            <TableRow style={{ background: "#f1f5f9" }}>
                                                <TableCell>PO Order ID</TableCell>
                                                <TableCell>Invoice No.</TableCell>
                                                <TableCell>Approved By</TableCell>
                                                <TableCell>Approved At</TableCell>
                                                <TableCell align="right">Inwarded Qty</TableCell>
                                                <TableCell align="right">Inwarded Rate (₹)</TableCell>
                                                <TableCell align="right">Inwarded Value (₹)</TableCell>
                                                <TableCell align="right">GST (₹)</TableCell>
                                                <TableCell align="right">Freight (₹)</TableCell>
                                                <TableCell align="right">Total (₹)</TableCell>
                                                <TableCell align="right">Paid (₹)</TableCell>
                                                <TableCell align="right">Outstanding (₹)</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {editPayments.length === 0 ? (
                                                <TableRow>
                                                    <TableCell colSpan={12} align="center">
                                                        No pending payments found
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                editPayments.map((payment) => (
                                                    <TableRow key={payment.paymentId}>
                                                        <TableCell>{payment.orderId}</TableCell>
                                                        <TableCell>{payment.invoiceNumber || "N/A"}</TableCell>
                                                        <TableCell>{payment.raisedBy}</TableCell>
                                                        <TableCell>
                                                            {payment.raisedAt
                                                                ? moment(payment.raisedAt).format("DD/MM/YYYY")
                                                                : "N/A"}
                                                        </TableCell>
                                                        <TableCell align="right">{payment.inwardedQty}</TableCell>
                                                        <TableCell align="right">{fmtINR(payment.inwardedRate)}</TableCell>
                                                        <TableCell align="right">{fmtINR(payment.inwardedValue)}</TableCell>
                                                        <TableCell align="right">
                                                            {fmtINR(payment.gstAmount)}
                                                            <Typography variant="caption" color="textSecondary" display="block">
                                                                @ {payment.gstRate}%
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell align="right">{fmtINR(payment.freightCharge)}</TableCell>
                                                        <TableCell align="right">{fmtINR(payment.payableAmount)}</TableCell>
                                                        <TableCell align="right">{fmtINR(payment.paidAmount)}</TableCell>
                                                        <TableCell align="right" style={{ fontWeight: 600 }}>
                                                            {fmtINR(payment.remainingAmount)}
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            label="Total Outstanding"
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            disabled
                                            value={fmtINR(editTotals.remainingAmount)}
                                            InputLabelProps={{ style: { color: "#b45309", fontWeight: 700 } }}
                                            InputProps={{ style: { color: "#b45309", fontWeight: 700, fontSize: "1.05rem" } }}
                                            inputProps={{ style: { color: "#b45309", WebkitTextFillColor: "#b45309" } }}
                                            helperText={
                                                <span style={{ fontWeight: 700, color: "#059669" }}>
                                                    Paid so far ₹{fmtINR(editTotals.paidAmount)} of ₹{fmtINR(editTotals.payableAmount)}
                                                </span>
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            label="Amount to Pay Now"
                                            type="number"
                                            required
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            value={editAmount}
                                            onChange={(e) => setEditAmount(e.target.value)}
                                            error={isEditAmountInvalid()}
                                            helperText={getEditAmountHelper()}
                                            FormHelperTextProps={{
                                                style: { fontWeight: 700, color: isEditAmountInvalid() ? "#dc2626" : "#2563eb" },
                                            }}
                                            InputLabelProps={{ style: { fontWeight: 700 } }}
                                            InputProps={{ style: { color: "#2563eb", fontWeight: 700, fontSize: "1.05rem" } }}
                                            inputProps={{ min: 0, max: editTotals.remainingAmount, step: "0.01" }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            label="Remark"
                                            required
                                            variant="outlined"
                                            fullWidth
                                            multiline
                                            minRows={2}
                                            value={editRemark}
                                            onChange={(e) => setEditRemark(e.target.value)}
                                            error={!editRemark.trim()}
                                            helperText={!editRemark.trim() ? "Remark is required" : ""}
                                        />
                                    </Grid>
                                </Grid>
                            </>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => setEditModalOpen(false)}
                            disabled={editSaving}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={downloadEditPaymentsExcel}
                            disabled={editLoading || editPayments.length === 0}
                        >
                            Download Excel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleEditSave}
                            disabled={
                                editLoading ||
                                editSaving ||
                                editPayments.length === 0 ||
                                isEditAmountInvalid() ||
                                !editRemark.trim()
                            }
                            startIcon={editSaving ? <Oval size={16} color="inherit" /> : null}
                        >
                            {editSaving ? "Saving..." : "Save"}
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </div>
    );
};
export default connect(null, { setLoading, setSnackInfo })(VendorPOPayment);
